import React, { useEffect } from 'react';

import { Spinner } from '@thefarmersfront/kitchen';

import { useIsMounted, useLogout } from '~/hooks/common';

const LogoutPage = () => {
  const isMounted = useIsMounted();

  const { logout } = useLogout();

  useEffect(() => {
    if (isMounted) {
      logout();
    }
  }, [isMounted]);

  return <Spinner fullscreen={{ dimmed: false }} />;
};

export default LogoutPage;
